import httpApi from "@src/utils/httpApi";
import { IManagerConfiguration } from "@src/types/managerConfiguration";
import { AxiosResponse } from "axios";

export const fetchMyManagerConfiguration = (): Promise<
  AxiosResponse<{ data: IManagerConfiguration }>
> => httpApi.get("/api/managers/me/configurations");
